import createEntityGraphNodeList from "../../lib/core/engine/EntityGraphNode/createEntityGraphNodeList"
import createSharedCachedFactory from "./createSharedCachedFactory"

export const createSharedEntityGraphNodeListMemo = createSharedCachedFactory(createEntityGraphNodeList)